import { ErrorResponse, Uuid } from 'ValueObjects';
import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from '@tanstack/react-query';

export type DisableTwoFactorMutationProps = {
  userId: Uuid;
  password: string;
  code: string;
};

export const DisableTwoFactorMutation = async ({
  ...values
}: DisableTwoFactorMutationProps): Promise<AxiosResponse> =>
  axios.put(`api/users/${values.userId}/disable-two-factor`, {
    ...values,
  });

export const useDisableTwoFactorMutation = (
  options: UseMutationOptions<
    AxiosResponse,
    AxiosError<ErrorResponse>,
    DisableTwoFactorMutationProps
  > = {}
): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorResponse>,
  DisableTwoFactorMutationProps
> =>
  useMutation<
    AxiosResponse,
    AxiosError<ErrorResponse>,
    DisableTwoFactorMutationProps
  >(DisableTwoFactorMutation, {
    useErrorBoundary: false,
    ...options,
  });
